
export default "/assets/arrow-uturn-right-micro.fdd8f7f4.svg"